<template>
  <div class="tool-panel">
    <div class="header">
      <q-tabs :value="activeToolbar" inline-label color="secondary" @input="setActiveToolbar">
        <template v-for="tab of tabs">
          <q-tab :key="tab.id" :name="tab.name" :label="tab.label" />
        </template>
      </q-tabs>
    </div>
    <div class="content overflow-hidden">
      <q-tab-panels :value="activeToolbar" class="fit" animated transition-prev="scale" transition-next="scale">
        <q-tab-panel name="savedReports">
          <SavedReports />
        </q-tab-panel>

        <q-tab-panel name="reportColumns">
          <ReportColumns />
        </q-tab-panel>
      </q-tab-panels>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    SavedReports: () => import('./SavedReports'),
    ReportColumns: () => import('./ReportColumns')
  },

  computed: {
    ...mapState('reports', ['activeToolbar', 'routerView', 'showReportColumns']),

    tabs() {
      let tabs = [{ id: 1, name: 'savedReports', label: 'Saved Reports' }]

      if (this.showReportColumns) {
        tabs.push({ id: 2, name: 'reportColumns', label: 'Report Columns' })
      }

      return tabs
    }
  },

  methods: {
    ...mapMutations('reports', ['setActiveToolbar'])
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

>>> .q-tab-panel {
  padding 0
}

.tool-panel {
  display grid
  grid-template-rows 50px 1fr
  border-left 2px solid $secondary
  overflow hidden

  .header {
    position relative

    &:before {
      content ""
      background white
      height 48px
      left 0
      position absolute
      top 0
      width 2px
    }

    &:after {
      content ""
      background white
      height 48px
      right 0
      position absolute
      top 0
      width 2px
    }
  }
}
</style>
